export const sprachen = ['DE', 'FR', 'IT'] as const;
export type Sprache = typeof sprachen[number];
